import * as actionTypes from './actionTypes';

export const storePlatformSearchInputValue = (data) => ({
  payload: data,
  type: actionTypes.PLATFORM_SEARCH,
});
export const clearPlatformSearchInputValue = (data) => ({
  payload: data,
  type: actionTypes.CLEAR_PLATFORM_SEARCH_INPUT_VALUE,
});
export const setActiveBlog = (id) => ({
  payload: id,
  type: actionTypes.ACTIVE_BLOG,
});
export const showToast = (
  message,
  type = 'info',
  duration = 3000,
  persistent = false,
  closable = false
) => ({
  type: actionTypes.SHOW_TOAST,
  payload: {
    closable,
    duration,
    message,
    persistent,
    type,
  },
});
export const setOnlineStatus = (status) => ({
  payload: status,
  type: actionTypes.SET_ONLINE_STATUS,
});

export const hideToast = () => ({
  type: actionTypes.HIDE_TOAST,
});
